import angular from 'angular';
import addNoteLauncher from './addNoteLauncher';

export default angular
  .module('components.addNoteLauncher', [])
  .component('addNoteLauncher', addNoteLauncher).name;
